const MPP_LOCALE_EXCEPTIONS = ["en", "US-es", "US-zh", "US-vi"];

export default {
  methods: {
    getMarketAndLanguage() {
      let market = "US";
      let language = "en";

      const aemLocalePattern = /[a-z]{2}_[A-Z]{2}/;
      const localeArray = window.location.href.match(aemLocalePattern);

      if (localeArray) {
        const locale = localeArray[0].split("_");

        if (!MPP_LOCALE_EXCEPTIONS.includes([locale[1], locale[0]].join("-"))) {
          language = locale[0].toLowerCase().trim();
          market = locale[1].toLowerCase().trim();
        }
      }

      return {
        market,
        language
      };
    },

    buildProductLink(slug, sku) {
      const { market, language } = this.getMarketAndLanguage();
      const isNewPdp =
        typeof window.isNewPdp !== "undefined" ? window.isNewPdp : false;

      let pdpLink = `/content/nuskin/${language}_${market.toUpperCase()}/products/product.${sku}.html`;

      if (isNewPdp) {
        pdpLink = `/catalog/${market}/${language}/product/${slug}`;
      }

      return pdpLink;
    },
    currencyFormatter(currencyLocale, style, currency, price) {
      const resolvedCurrencyLocale = this.resolveCurrencyLocale(currencyLocale);
      const formatter = new Intl.NumberFormat(resolvedCurrencyLocale, {
        maximumFractionDigits: 2,
        currency: currency,
        style: style
      });
      return formatter.format(price);
    },
    resolveCurrencyLocale(currencyLocale) {
      const localeArray = currencyLocale.split("-");
      let language = localeArray[0];
      const market = localeArray[1];

      /*
        CX32-2339: Product currency for en_CZ locale should be Kč instead of CZK.
        We'll change the language from en to cs in order to change the currency symbol to Kč.
      */
      if (language === "en" && market === "CZ") {
        language = "cs";
        return `${language}-${market}`;
      }

      return currencyLocale;
    }
  }
};
